"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("../enums");
/**
 * Abstract base class used we would like appenders to implement.
 */
var Appender = /** @class */ (function () {
    function Appender() {
        /**
         * Determines the type of the appender.
         */
        this.type = enums_1.AppenderType.Empty;
    }
    return Appender;
}());
exports.Appender = Appender;
